import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { connect } from "react-redux";
import { ViewCountProduct } from "../../../api/products";
import { getCookie } from "../../../common/auth";
import { priceComma } from "../../../common/splicePrice";
import { getDate } from "../../../common/util/getDate";
import { insertBasketsAction } from "../../../redux/action/baskets";
import { addToCart } from "../../../redux/action/cart";
import * as List from "./Proucts-list-styles";

const TableTypeList = ({
  productList,
  searchList,
  basketsItems,
  cartItems,
  basketsCount,
  dummyList,
  addToCart,
  insertBasketsAction,
  purchaseDirect,
  addCart,
  inCart,
  viewFeature,
  products,
}) => {
  const router = useRouter();

  const inBasket = (product) => {
    return inCart
      ? inCart(product)
      : basketsItems?.find(
          (basketsItem) => basketsItem.pcode === product.pcode
        ) || cartItems?.find((cartItem) => cartItem.pcode === product.pcode);
  };

  // 장바구니 담기
  const handleCart = async (product) => {
    if (product) {
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [
            {
              item_name: product.pname, // 상품 이름
              item_id: product.pcode, // 상품 ID
              price: product.price, // 상품 개별 가격
              item_brand: product.supplier, // 브랜드이름
              item_category:
                product.category_code.length > 2
                  ? product.category_code
                  : dummyList?.category[product.category_code], // 대 카테고리
            },
          ],
        },
      });
      // 채널톡 장비구니 이벤트
      window.ChannelIO("track", "AddToCart", {
        pcode: product.pcode,
      });
    }

    if (!getCookie("token")) {
      return addToCart(product);
    } else {
      return insertBasketsAction(product, 1);
    }
  };

  const moveToDetail = async (product) => {
    const body = {
      modes: "ViewCount",
      pcode: product.pcode,
    };
    const res = await ViewCountProduct(body);
    const DATE = getDate();
    const todays = JSON.parse(sessionStorage.getItem(`${DATE}`) || "[]");
    const tempToday = todays.filter((el) => el === product.pcode);
    if (tempToday.length) {
      return;
    }
    todays.push(product.pcode);
    sessionStorage.setItem(`${DATE}`, JSON.stringify(todays));
    const url = `/products/${product.ename}/${product.pcode}/`;
    router.push(url);
  };

  return (
    <>
      <List.TableTypeWrapper>
        <List.Table>
          <thead>
            <tr className="header">
              <th className="img">이미지</th>
              <th className="name">품명</th>
              <th className="sizes">사이즈</th>
              {(router.query.code === "01" || router.query.code === "02") && (
                <>
                  <th className="golgi">골</th>
                  <th className="strength">지종</th>
                </>
              )}
              {(router.query.code === "05" || viewFeature) && (
                <th className="feature">주원료</th>
              )}
              <th className="onePrice">단가</th>
              <th className="quantity">묶음 수량</th>
              <th>판매가</th>
              <th>구매</th>
            </tr>
          </thead>
          <tbody>
            {searchList?.length > 0 || productList?.length > 0 ? (
              (router.query.search ? searchList : productList).map(
                (product, i) => (
                  <tr key={i}>
                    <td className="img">
                      <Link
                        href={`/products/${product.ename}/${product.pcode}/`}
                      >
                        <a onClick={() => moveToDetail(product)}>
                          <img src={product.main_image} alt={product.pname} />
                        </a>
                      </Link>
                    </td>
                    <td className="name">
                      <Link
                        href={`/products/${product.ename}/${product.pcode}/`}
                      >
                        <a onClick={() => moveToDetail(product)}>
                          {product.pname}
                        </a>
                      </Link>
                    </td>
                    <td className="sizes">
                      {product.horizontal == 0 &&
                      product.vertical == 0 &&
                      product.height == 0 ? (
                        "-"
                      ) : (
                        <div>
                          {product.horizontal != 0
                            ? "가로: " + product.horizontal
                            : ""}
                          <br />
                          {product.vertical != 0
                            ? "세로: " + product.vertical
                            : ""}
                          <br />
                          {product.height != 0 ? "높이: " + product.height : ""}
                        </div>
                      )}
                    </td>
                    {(router.query.code === "01" ||
                      router.query.code === "02") && (
                      <>
                        <td className="golgi">{product.golgi}</td>
                        <td className="strength">{product.strength}</td>
                      </>
                    )}
                    {(router.query.code === "05" || viewFeature) && (
                      <td className="feature">
                        {product.feature ? product.feature : "-"}
                      </td>
                    )}
                    <td className="onePrice">
                      {Number(product.quantity) < 1
                        ? "-"
                        : priceComma(
                            Math.floor(
                              Number(product.discount_price) /
                                Number(product.quantity)
                            )
                          ) + "원"}
                    </td>
                    <td className="quantity">
                      {product.quantity == 0
                        ? "-"
                        : priceComma(product.quantity) + "개"}
                    </td>
                    <td className="price">
                      <List.PriceBox>
                        {product.salePer > 0 && (
                          <div>
                            <span>
                              {product.price &&
                                ` ${priceComma(product.price)}원`}
                            </span>
                          </div>
                        )}
                        {priceComma(product.discount_price)}원
                      </List.PriceBox>
                    </td>
                    <td className="btnWrapper">
                      <List.BtnWrapper>
                        {product.sold_out === "Y" ? (
                          <>
                            <span>품절</span>
                          </>
                        ) : (
                          <>
                            {purchaseDirect && (
                              <List.CheckoutBtn
                                onClick={purchaseDirect(product)}
                              >
                                바로 결제하기
                              </List.CheckoutBtn>
                            )}
                            {!inBasket(product) ? (
                              <List.CartBtn
                                className="mobonCart"
                                onClick={() =>
                                  addCart
                                    ? addCart(product)
                                    : handleCart(product)
                                }
                              >
                                장바구니 담기
                              </List.CartBtn>
                            ) : (
                              <List.CartBtn
                                onClick={() =>
                                  addCart
                                    ? addCart(product)
                                    : handleCart(product)
                                }
                                inCart
                              >
                                장바구니 담김
                              </List.CartBtn>
                            )}
                          </>
                        )}
                      </List.BtnWrapper>
                    </td>
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan={999}>조건에 맞는 상품이 없습니다.</td>
              </tr>
            )}
          </tbody>
        </List.Table>
      </List.TableTypeWrapper>
    </>
  );
};

const mapStateToProps = (state) => ({
  products: state.products,
  cartItems: state.cart,
  basketsItems: state.baskets.items,
  basketsCount: state.baskets.count,
});

const mapDispatchToProps = { addToCart, insertBasketsAction };

export default connect(mapStateToProps, mapDispatchToProps)(TableTypeList);
